import { ForwardFn, forwardRef } from 'preact/compat'
import { useParentWindowSize } from 'scripts/hooks'
import { h } from 'preact'
import cls from 'classnames'

import classes from './index.scss'

type Props = {
  title: string
  className?: string
}

const FieldTitle: ForwardFn<Props, HTMLDivElement> = ({ title, className }, ref) => {
  const { windowSizeSm } = useParentWindowSize()
  return (
    <div className={cls(classes.fieldTitle, windowSizeSm && classes.mobileFieldTitle, className)} ref={ref}>
      {title}
    </div>
  )
}

export default forwardRef(FieldTitle)
